<template>
  <div>
    <LsLayout>
      <div class="form-container container">
        <div class="form-bg top hidden-xs"></div>
        <div class="form-bg bot hidden-xs"></div>
        <div class="form-body">
          <div class="form-tabs">
            <div :class="['tab', { 'tab-active': active == '01' }]" @click="active = '01'">账号密码登录</div>
            <div :class="['tab', { 'tab-active': active == '02' }]" @click="active = '02'">手机验证码登录</div>
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ls-form" @keydown.enter.native="onSubmit">
            <el-form-item prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号">
                <img class="prop-icon" src="../assets/images/icon-tel.png" slot="prefix" />
              </el-input>
            </el-form-item>
            <el-form-item prop="password" v-if="active == '01'">
              <el-input v-model="ruleForm.password" type="password" placeholder="请输入登录密码">
                <img class="prop-icon" src="../assets/images/icon-pwd.png" slot="prefix" />
              </el-input>
            </el-form-item>
            <el-form-item prop="code" v-if="active == '02'">
              <el-input v-model="ruleForm.code" placeholder="请输入短信验证码" :maxlength="6">
                <img class="prop-icon" src="../assets/images/icon-code.png" slot="prefix" />
                <el-button slot="suffix" type="text" class="send" :disabled="disabled" @click="handleSendCode">
                  {{ verifyCode }}
                </el-button>
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="name">
              <el-input v-model="ruleForm.name" placeholder="请再次输入登录密码">
                <img class="prop-icon" src="../assets/images/icon-pwd.png" slot="prefix" />
              </el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button @click="onSubmit" class="btn-sumbit">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="form-forget">
            <div class="pwd primary" @click="$router.push('/forget')">忘记密码</div>
            <div class="register">数据蜂新客户，<span class="primary"
                @click="$router.push({ path: `/register`, query: $route.query || {} })">立即注册</span></div>
          </div>
        </div>
      </div>
    </LsLayout>
  </div>
</template>
<script>
const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
// const regPassword = /^([a-z0-9\.\@\!\#\$\%\^\&\*\(\)]){6,20}$/i;
const regPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,20}$/;

export default {
  title: '登录',
  data () {
    return {
      active: "01",
      ruleForm: {},
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: regPhone, message: "请输入正确格式的手机号码", trigger: "blur" }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { pattern: regPassword, message: "请输入6-20位数字+字母的登录密码", trigger: "blur" }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: "请输入6位数字的验证码", trigger: "blur" }
        ],
      },
      count: 60,
      verifyCode: '发送验证码',
      disabled: false
    }
  },
  mounted () {
    this.active = this.$route.query.active || '01'
  },
  methods: {
    /**
     * 提交
     * @return {*}
     */
    onSubmit () {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          const { phone: username, password, code } = this.ruleForm
          const uri = this.active === '01' ? 'Login' : 'LoginByCode'
          const _param = this.active === '01' ? { username, password } : { username, code }
          this.handleLogin(uri, _param).then((res) => {
            this.$message.success('登录成功')
            sessionStorage.setItem('userinfo', JSON.stringify(res))
            setTimeout(() => {
              this.$router.push({ path: `/release_need` })
            }, 1000)
          }).catch(e => {
            this.$message.error(e)
          })
        }
      })
    },
    /**
     * 登录 
     * @param {*} uri
     * @param {*} record
     * @return {Promise}
     */
    handleLogin (uri, record) {
      return new Promise((resolve, reject) => {
        this.$post(`/ajaxApi/index.php?s=Client.IntentClient.${uri}`, record, (data, status, msg) => {
          if (status) {
            resolve(data)
          } else {
            reject(msg)
          }
        })
      })
    },
    /**
     * 发送验证码
     * @return {*}
     */
    handleSendCode () {
      if (this.disabled) return
      const { phone } = this.ruleForm;
      if (!phone || !regPhone.test(phone)) {
        return this.$message.error('请输入正确格式的手机号码')
      }
      this.$post('/ajaxApi/index.php?s=Client.IntentClient.SendLoginCode', { phone }, (data, status, msg) => {
        if (status) {
          this.disabled = true
          this.$message.success('验证码发送成功')
          this.handleCountDown();
        } else {
          this.$message.error(msg)
        }
      })
    },
    /**
    * 倒计时
    * @return {*}
    */
    handleCountDown () {
      const timer = setInterval(() => {
        this.count--;
        this.verifyCode = `${this.count}s后重新发送`
        if (this.count < 0) {
          clearInterval(timer)
          this.verifyCode = '重新获取验证码'
          this.count = 60
          this.disabled = false
        }
      }, 1000);
    },
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/view/login.vue